// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/iconify';
import SvgColor from '../../../components/svg-color';
import { NotificationWithdraws } from '../../../components/notification-withdraws';


// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const iconNew = (name) => (
  <Iconify icon={name} sx={{ width: 1, height: 1, opacity: .9 }}/>
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  faq: iconNew('ph:question'),
  contacts: iconNew('carbon:phone-filled'),
  stats: iconNew('ion:stats-chart'),
  source: iconNew('ic:outline-source'),
  tool: iconNew('mingcute:tool-fill'),
  home: iconNew('ic:round-home'),
  withdraw: iconNew('fluent:money-16-filled'),
  partners: iconNew('ic:round-person'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    
    items: [
      { title: 'Главная', path: PATH_DASHBOARD.general.app, icon: ICONS.home },
      { title: 'Статистика', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.stats },
      { title: 'Партнёры', path: PATH_DASHBOARD.partners.list, icon: ICONS.partners },
      { title: 'Финансы', path: PATH_DASHBOARD.general.withdraw, icon: ICONS.withdraw, info: <NotificationWithdraws/>, },
      { title: 'Промоматериалы', path: PATH_DASHBOARD.pr.materials, icon: ICONS.tool },
      { title: 'Аналитика', path: PATH_DASHBOARD.analytics.root, icon: ICONS.analytics },
    ],
  },
];

export default navConfig;
